import { render, staticRenderFns } from "./dongxin.vue?vue&type=template&id=b3e50e76&scoped=true&"
import script from "./dongxin.vue?vue&type=script&lang=js&"
export * from "./dongxin.vue?vue&type=script&lang=js&"
import style0 from "./dongxin.vue?vue&type=style&index=0&id=b3e50e76&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3e50e76",
  null
  
)

export default component.exports